import type { FC, ReactNode } from 'preact/compat';
import { useMemo, useState } from 'preact/compat';

import { tokenManager, getVkIdResponse } from '../../utils';

import { VkCaptchaContext } from './VkCaptchaContext';

interface Props {
  children: ReactNode;
}

const VkCaptchaProvider: FC<Props> = ({ children }) => {
  const { payload } = getVkIdResponse();
  const initialCaptchaPassed =
    Boolean(tokenManager.getToken()) || !tokenManager.getIsTokenExpired() || Boolean(payload);
  const [isCaptchaShown, setIsCaptchaShown] = useState(false);

  const [isCaptchaPassed, setIsCaptchaPassed] = useState(initialCaptchaPassed);

  const defaultProps = useMemo(() => {
    return {
      isCaptchaShown,
      setIsCaptchaShown,
      isCaptchaPassed,
      setIsCaptchaPassed,
    };
  }, [isCaptchaPassed, isCaptchaShown]);

  return <VkCaptchaContext.Provider value={defaultProps}>{children}</VkCaptchaContext.Provider>;
};

export { VkCaptchaProvider };
